<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    first_btn="Tenders.ReturnToTender"
    second_btn="Tenders.ToStopList"
    :title="`${$t('StopLists.AddedToStopList', {participant: participant ? participant.name || participant.usreou || participant : '' })}`"
    :without_first_btn="!$route.query.from"
    @apply="result(false)"
    @close="result(true)">
    <template #activator-btn>
      <sButton
        :disabled="disabled"
        :loading="loading"
        @click="action">
        {{ $t('Common.Add') }}
      </sButton>
    </template>
    <template #card-text>
      {{ $t('StopLists.InStpList') }}
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { stopListsMixin } from 'mixins'

export default {
  name: 'stoppedDialog',
  mixins: [stopListsMixin],
  data() {
    return {
      dialog: false,
    }
  },
  props: {
    disabled: Boolean,
    loading: Boolean,
    participant: [Object, String],
    add: Function,
    validate: Function,
  },
  methods: {
    async action() {
      if (this.validate && typeof this.validate === 'function') {
        await this.validate().then(async (result) => {
          if (result) {
            await this.add()
              .then((result) => {
                if (result) {
                  this.dialog = true
                }
              })
          } else {
            this.$notice.info({
              title: this.$t('Common.PleaseNote'),
              message: this.$t('Validate.checkRequiredFelds'),
              showClose: true,
              progress: true,
              duration: 10
            })
          }
        })
      } else {
        await this.add()
        this.dialog = true
      }
    },
    result(closed = false) {
      this.dialog = false
      this.$nextTick(() => {
        this.close(closed)
      })
    },
  },
  components: {
    DialogTemplateToolkit
  }
}
</script>
